import { render } from "./StartScreen.vue?vue&type=template&id=1bed9d24&bindings={\"highscore\":\"props\",\"games\":\"props\",\"setDifficulty\":\"setup\"}"
import script from "./StartScreen.vue?vue&type=script&lang=js"
export * from "./StartScreen.vue?vue&type=script&lang=js"
script.render = render

export default script